import makeStyles from "@mui/styles/makeStyles";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

export const ProductSectionDivider = styled(Divider)(() => ({
  margin: "16px 0",
}));

export const CartonDimensionDivider = styled(Divider)(() => ({
  marginTop: "16px",
}));

const styles = makeStyles<Theme>((theme) => ({
  container: {
    fontFamily: "Manrope !important",
  },
  tabs: {
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
    padding: "16px 32px",
  },
  uiTab: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
  },
  titleData: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "13px",
    lineHeight: "16px",
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginRight: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
  titleDataContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
  },
}));

export default styles;
